/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stocks } from './Stocks';
import {
    StocksFromJSON,
    StocksFromJSONTyped,
    StocksToJSON,
    StocksToJSONTyped,
} from './Stocks';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseStock
 */
export interface ResponseStock {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseStock
     */
    result: ResponseResult;
    /**
     * 
     * @type {Stocks}
     * @memberof ResponseStock
     */
    data: Stocks;
}

/**
 * Check if a given object implements the ResponseStock interface.
 */
export function instanceOfResponseStock(value: object): value is ResponseStock {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseStockFromJSON(json: any): ResponseStock {
    return ResponseStockFromJSONTyped(json, false);
}

export function ResponseStockFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseStock {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': StocksFromJSON(json['data']),
    };
}

export function ResponseStockToJSON(json: any): ResponseStock {
    return ResponseStockToJSONTyped(json, false);
}

export function ResponseStockToJSONTyped(value?: ResponseStock | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': StocksToJSON(value['data']),
    };
}

